var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitch = function SvgTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#5A3E85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M42.776 48.366h-7.034l-4.69 4.594h-4.694v-4.594H17.76V23.882l2.346-6.122H52.16v21.428l-9.384 9.178zm6.258-10.712V20.818H23.23V43.01h7.04v4.588l4.689-4.588h8.6l5.474-5.357zm-17.202-1.528v-9.182h3.128v9.182h-3.128zm8.6 0v-9.182h3.127v9.182h-3.127z"
  }))));
};
export default SvgTwitch;